import React, {useEffect, useRef} from 'react';
import TopBar from './TopBar.mjs';
import ColumnsTree from './ColumnsThree.mjs';

export default function FullDisplay({sign_out}) 
{
    return (
        <>
            <TopBar sign_out={sign_out} />
            <ColumnsTree />
        </>
    );
}

